import { gql } from '@apollo/client';

export const LEND_DOCUMENTS_QUERY = gql`
  query {
    landaFinancingReit {
      documents {
        title
        uri
      }
    }
  }
`;
